import {client} from "./ApiClient";
import {mapServiceUrls} from "../Helpers/Globals";
import {useMutation, useQuery, useQueryClient} from "react-query";

const redeemCoupon = ({urls, accessKey, customerUid, code, uid, quantity}) => {
    return client(mapServiceUrls(urls).LoyaltyEngineApiUrl, `api/v4/${accessKey}/coupons/commands/redeem`, {
        body: {
            CustomerUid: customerUid,
            CouponCode: code,
            CouponUid: uid,
            Quantity: quantity,
        }
    })
}

export default function useRedeemCoupon() {
    const queryClient = useQueryClient();
    return useMutation(redeemCoupon, {
        onSuccess: (data) => {
            // Invalidate customerCoupons queries (matches ['customerCoupons', uid] for all uids)
            queryClient.invalidateQueries(['customerCoupons']);
            // Invalidate customer queries (matches ['customer', uid] for all uids)
            queryClient.invalidateQueries(['customer']);
        }
    });
}